import App from './App.svelte';
try {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js')
                .then((registration) => {
                //   console.log('Service worker registered: ', registration)
                if (registration.waiting) {
                    // Hay un Service Worker esperando para activarse
                    registration.waiting.postMessage({ type: 'skipWaiting' });
                }
            })
                .catch((registrationError) => {
                console.log('Service worker registration failed: ', registrationError);
            });
        });
    }
    const app = new App({
        target: document.body,
        props: {
            name: 'world'
        }
    });
}
catch (error) {
    console.log(error);
}
